import { render, staticRenderFns } from "./GarnituresList.vue?vue&type=template&id=5cabdc42&"
import script from "./GarnituresList.vue?vue&type=script&lang=js&"
export * from "./GarnituresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports